// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__dJHsv","spin":"Loader_spin__35N7v"};